angular.module('vastdesk').
  component('displayDayparting', {
    bindings: {
      dayParting: '<',
      usersTimezone: '<',
      commaSeparated: '<?'
    },
    template: require("../templates/displayDayparting.html"),
    controllerAs: '$displayDaypartingCtrl',
    controller: function() {
      const self = this;

      const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      const formatHour = function(hour, minutes) {
        const period = hour < 12 ? 'am' : 'pm';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        return hour12 + ':' + minutes + ' ' + period;
      };

      const getHourSegments = function(hours) {
        const segments = [];
        let segmentStart = null;
        let segmentEnd = null;

        for (let i = 0; i < hours.length; i++) {
          const isOn = !!hours[i];
          if (isOn) {
            if (segmentStart === null) segmentStart = i;
            segmentEnd = i;
          }
          if (isOn && i !== 23) continue;
          if (segmentStart === null) continue;

          segments.push(formatHour(segmentStart, '00') + ' - ' + formatHour(segmentEnd, '59'));
          segmentStart = null;
          segmentEnd = null;
        }

        return segments;
      };

      const buildLines = function(dayParting) {
        if (!Array.isArray(dayParting) || dayParting.length === 0) return [];

        const lines = [];
        dayParting.forEach(function(hours, day) {
          if (!Array.isArray(hours) || !hours.some(function(h) { return !!h; })) return;
          lines.push({
            name: DAY_NAMES[day],
            segments: getHourSegments(hours).join(', ')
          });
        });

        return lines;
      };

      this.$onChanges = function() {
        self.lines = buildLines(self.dayParting);
      };
    }
  });
